/**
 * Safely parses JSON with error handling
 * Prevents crashes from malformed JSON in localStorage or API responses
 */
export function safeJsonParse<T = any>(json: string | null, fallback: T): T {
  if (!json || json.trim() === '') {
    return fallback
  }

  try {
    const parsed = JSON.parse(json)
    return parsed as T
  } catch (error) {
    console.warn('Failed to parse JSON:', error, 'Raw value:', json)
    return fallback
  }
}

/**
 * Safely parses JSON from localStorage
 */
export function safeLocalStorageParse<T = any>(key: string, fallback: T): T {
  try {
    const item = window.localStorage.getItem(key)
    return safeJsonParse<T>(item, fallback)
  } catch (error) {
    console.warn(`Failed to read from localStorage key "${key}":`, error)
    return fallback
  }
}
